import React, { useEffect, useState } from 'react';
import 'boxicons/css/boxicons.min.css';
import './Section1.scss';
import drMain from '../../../../assets/images/HomePageImages/mainDr.png';
import drMobile from '../../../../assets/images/HomePageImages/mainDrResponsive.png';
const Section1 = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [currentImage, setCurrentImage] = useState(drMain);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        setCurrentImage(windowWidth <= 1050 ? drMobile : drMain);
    }, [windowWidth]);
    return (
        <div className='home-page-section section-1'>
            <div className='home-page-section-content text'>
                <h1>Promoting and Preserving <span className="highlight">Physical and Cognitive Health</span></h1>
                <p>At Virginia Rehab Physicians, we are committed to supporting the millions of individuals facing functional decline due to aging or complex medical conditions in inpatient rehab facilities, acute care hospitals, and skilled nursing facilities. Through our clinics, we deliver advanced physical medicine and rehabilitation (physiatry) care, ensuring patients and their families receive the highest quality support and treatment wherever it is needed.</p>
                <div className='button-section'>
                    <a className='btn' href="/patients-and-families">
                        <i className='bx bx-plus'></i>
                        For Patients
                    </a>
                    <a className='btn' href="/facilities-page">
                        <i className='bx bx-plus'></i>
                        For Facilities
                    </a>
                </div>
            </div>
            <div className='home-page-section-content'>
                <div className='image-container'>
                    <img src={currentImage} alt="" />
                </div>
            </div>
        </div>
    );
};

export default Section1;
